<template>
<div :class="search_status ? 'index page_map page_item page_search page_limit' : 'index page_map page_item page_search'">
    <div class="top_wrap">
        <div class="index_top top_nobg">
            <div class="PageSearch page-search">
                <!-- <van-row type="flex" justify="space-start">
                    <van-col span="3">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :span="searchlefticon !='' && searchrighticon != '' ? 18 : searchlefticon !=''|| searchrighticon != '' ? 20 : 22">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder">
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row> -->
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder">
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
        </div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <!-- 选择省份 -->
            <div class="search_t" @click="areaPicker= true">
                <div class="search_nr">
                    <div class="search_t_l"></div>
                    <div class="search_t_m">
                        <van-field v-model="selectArea" placeholder="请选择省市区" :readonly="true" />
                    </div>
                    <div class="search_t_r"></div>
                </div>
            </div>
            <!-- 选择项目 -->
            <div class="search_fenlei">
                <div class="search_title">选择项目</div>
                <ul class="search_list clearfix">
                    <li :class="item.status ? 'search_item f-l type active' : 'search_item f-l type'" v-for="item in typeList" :key="item.type_id" :data-id="item.type_id" @click="clickType(item)">{{item.name}}</li>
                </ul>
            </div>
            <!-- 选择等级 -->
            <div class="search_fenlei">
                <div class="search_title">选择级别</div>
                <ul class="search_list clearfix">
                    <li :class="item.status ? 'search_item f-l level active':'search_item f-l level'" v-for="item in levelList" :key="item.id" :data-id="item.id" @click="clickLevel(item)">{{item.title}}</li>
                </ul>
            </div>
            <!-- 选择分类 -->
            <div class="search_fenlei">
                <div class="search_title">选择分类</div>
                <ul class="search_list clearfix">
                    <li :class="item.status ? 'search_item f-l cate active': 'search_item f-l cate'" v-for="item in cateList" :key="item.id" :data-id="item.id" @click="clickCate(item)">{{item.name}}</li>
                </ul>
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 列表 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false" class="itemList">
        <div class="content">
            <ul class="list">
                <li class="item clearfix" v-for="(item,index) in dataList" :key="index">
                    <div class="thumb f-l" @click="goItemInfo(item.id)" v-if="item.item">
						<van-image fit="contain" :show-loading="false" :src="item.item.thumb ? imageUrl+item.item.thumb : item.item_first_tu ? imageUrl+item.item_first_tu : $publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
                        <!-- <img :src="item.item.thumb ? item.item.thumb : item.item_first_tu ? item.item_first_tu : $publicData.intangibleDefault" alt style="height:100%" /> -->
                    </div>
                    <div class="info f-l">
                        <div class="title clearfix" @click="goItemInfo(item.id)">
                            <!-- <div class="f-l tag" v-if="item.item.level">{{item.item.level.title}}</div>
                            <span class="f-l txt">{{item.title}}</span> -->
                            <span class="tag" v-if="item.item.level">「{{item.item.level.title}}」</span>
                            <span class="txt">{{item.title}}</span>
                        </div>
                        <div class="juli clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l tag" v-if="item.item.cate">{{item.item.cate.name}}</span>
                            <span class="f-r num" v-if="item.distance>0">距离约 {{(item.distance/1000).toFixed(2)}}千米</span>
                        </div>
                        <div class="adress clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l">地址：</span>
                            <div class="f-l detail">
                                <span v-if="item.item.area1">{{item.item.area1.areaname ? item.item.area1.areaname : ''}}</span>
                                <span v-if="item.item.area2">{{item.item.area2.areaname ? '>'+ item.item.area2.areaname : ''}}</span>
                                <span v-if="item.item.area3">{{item.item.area3.areaname ? '>'+ item.item.area3.areaname : ''}}</span>
                            </div>
                        </div>
                        <div class="bottom clearfix">
                            <div class="action f-l" @click="goShop(item.tradesman_id)">店铺</div>
                            <div class="action f-l" @click="goSomeWhere(item.lng,item.lat,item.title)">去这里</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
import areaList from "./../area.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "map-quanguo",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan.png', // 搜索栏右侧图标
            search_value: '', // 搜索值
            readonly: true, // 搜索栏只读
            placeholder: '请输入要搜索项目',
            righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
            publicPath: process.env.BASE_URL,
            cate_id: null, // 类型id
            type_id: null, // 项目id
            // area_name: this.$route.query.area_name, // 是个字符串 如： 河北省-衡水市-桃城区 ; 全国选到省份这一级 只显示到 河北省
            level_id: null, // 等级id
            pages: {
                page: 1,
                size: 10
            },
            loading: true,
            finished: false,
            dataList: [], // 数据
            selectArea: '全国', // 搜索 地区 默认是从全国地区筛选过来的省份 格式'河北省-衡水市-桃城区'
            areaPicker: false, // 地区弹层
            areaList: areaList, // 地区弹层数据 全国省市区
            areaNameList: null, // 地区数组名称 [省，市，县]
            cateList: null, // 分类数组
            search_status: false, // 筛选层是否展开
            typeList: [], // 项目类型列表
            levelList: [], // 等级分类列表
            typeIdList: [], // 项目id数组
            levelIdList: [], // 等级id数组
            cateIdList: [], // 类型id数组
            lng: localStorage.getItem('lng') ? localStorage.getItem('lng') : localStorage.getItem('lngDefault'),
            lat: localStorage.getItem('lat') ? localStorage.getItem('lat') : localStorage.getItem('latDefault'),
            token: ''
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        // console.log('this.$route.query')
        // console.log(this.$route.query)
        if (this.$route.query.search && this.$route.query.search != undefined || this.$route.query.search != '') {
            this.search_value = this.$route.query.search
        }
        var searchStr = localStorage.getItem('searchParams')
        if (searchStr && searchStr != undefined && searchStr != '') {
            var params = JSON.parse(searchStr)
            if (params.areaNameList) {
                this.areaNameList = params.areaNameList
                var str = ''
                for (var i in this.areaNameList) {
                    if (i == 0) {
                        str = str + this.areaNameList[i]
                    } else if (i == 1) {
                        str = '-' + str + this.areaNameList[i]
                    } else if (i == 2) {
                        str = '-' + str + this.areaNameList[i]
                    }
                }
                this.selectArea = str
            }
            this.type_id = params.type_id
            this.levelIdList = params.levelIdList
            this.cateIdList = params.cateIdList
        }
        var arr = []
        if (this.type_id && this.type_id != undefined && this.type_id != '') {
            arr.push(this.type_id)
        }
        this.typeIdList = arr

        this.getTypeList()
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '项目列表'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                // 获取类别
                this.getCateList()
            })
            //获取定位信息
            var params2 = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://public/getLocationInfo', params2, (data) => {
                console.log(111111111)
                console.log(data)
                if (data.code == 200) {
                    this.lat = data.result.latitude
                    this.lng = data.result.longitude
                } else {
                    this.lat = null
                    this.lng = null
                }
                this.dataList = []
                this.pages.page = 1
                this.onLoad()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            // 获取类别
            this.getCateList()
            this.onLoad()
        }
        // console.log(this.$refs.marker)
    },
    methods: {
        // 获取列表
        onLoad() {
            var params = {
                token: this.token,
                cateIdList: this.cateIdList,
                type_id: this.typeIdList,
                levelIdList: this.levelIdList,
                lng: this.lng,
                lat: this.lat,
                page: this.pages.page,
                size: this.pages.size
            }
            if (this.areaNameList) {
                params.area_name = this.areaNameList
                params.area_level = this.areaNameList.length
            }
            if (this.search_value) {
                params.key = this.search_value
            }
            // console.log('params', params)
            this.$api.map.searchItem(params).then(res => {
                if (res.code == 200) {
                    // console.log('res')
                    // console.log(res)
                    let list = []
					list = res.result
					if(list.length != 0){
						for(var i in list){
							// 无缩略图,取内容的第一张图片
							var content = list[i].item.content
							list[i].item_first_tu = this.imgUrlFun(content)
							this.dataList.push(list[i])
						}
						this.pages.page++;
                		this.loading = false;
					}else{
						this.finished = true
					}
                } else {
					this.finished = true
                    return;
                }
                // this.pages.page++;
				// this.loading = false;
				console.log('列表',this.dataList)
            })
        },
        // 项目详情
        goItemInfo(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?id=" + id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/item/detail" + p
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
                    path: "/item/detail",
                    query: {
                        id: id
                    }
                });
            }
        },
        // 去这里
        goSomeWhere(lng, lat, name) {
            console.log('window')
            console.log(window)
            window.location.href = '//uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + name
        },
        // 去店铺 绑的是匠人店铺
        goShop(id) {
            this.$router.push({
                path: '/art/detail',
                query: {
                    tradesmanId: id
                }
            })
        },
        // 点击左侧图标
        clicksearchleft() {
            // 没有左侧图标
            return;
        },
        // 触发focus
        showFullScreenSearchPage() {
            this.$router.push({
                path: '/search/index',
                query: {
                    search_type: '项目',
                    type_id: this.type_id
                }
            })
        },
        // 点击右侧图标
        clicksearchright() {
            // 没有右侧图标
            this.search_status = !this.search_status;
        },
        // 确认选中地区
        confrimArea(data) {
            this.areaPicker = false;
            var arr = []
            var str = ''
            for (var i = 0; i < data.length; i++) {
                if (data[i] && data[i].name) {
                    arr.push(data[i].name)
                }
            }
            for (var j = 0; j < arr.length; j++) {
                if (j == 0) {
                    str = arr[j]
                } else if (j == 1) {
                    str = str + '-' + arr[j]
                } else {
                    str = str + '-' + arr[j]
                }
            }
            this.areaNameList = arr
            this.selectArea = str
        },
        // 项目分类列表
        getTypeList() {
            var params = {
                token: this.token
            }
            this.$api.map.itemType(params).then(res => {
                if (res.code == 200) {
                    console.log('项目分类')
                    console.log(res)
                    this.typeList = res.result
                    for (var i in this.typeList) {
                        if (this.typeList[i].type_id == this.type_id) {
                            this.typeList[i].status = true
                        } else {
                            this.typeList[i].status = false
                        }
                    }
                    this.getLevelList(this.type_id)
                }

            })
        },
        // 项目级别
        getLevelList(type_id) {
            this.levelArr = []
            var params = {
                type_id: type_id
            }
            this.$api.map.levelList(params).then(res => {
                if (res.code == 200) {
                    var arr = res.result.list
                    console.log(arr)
                    this.levelList = res.result.list
                    for (var i in this.levelList) {
                        for (var j in this.levelIdList) {
                            if (this.levelList[i].id == this.levelIdList[j]) {
                                this.levelList[i].status = 1
                            } else {
                                this.levelList[i].status = 0
                            }
                        }
                        // if(this.levelList[i].id == this.level_id){
                        // 	this.levelList[i].status = 1
                        // }else{
                        // 	this.levelList[i].status = 0
                        // }
                    }
                }
            })
            console.log('levelList')
            console.log(this.levelList)
        },
        // 获取项目类型列表
        getCateList() {
            var params = {
                token: this.token,
                page: 1,
                size: 999
            }
            this.$api.map.cateList(params).then(res => {
                if (res.code == 200) {
                    console.log('获取项目分类列表')
                    console.log(res)
                    this.cateList = res.result.list
                    for (var i in this.cateList) {
                        for (var j in this.cateIdList) {
                            if (this.cateList[i].id == this.cateIdList[j]) {
                                this.cateList[i].status = 1
                            } else {
                                this.cateList[i].status = 0
                            }
                        }
                        // if(this.cateList[i].id == this.cate_id){
                        // 	this.cateList[i].status = 1
                        // }else{
                        // 	this.cateList[i].status = 0
                        // }
                    }
                }
            })
            console.log('levelList')
            console.log(this.levelList)
        },
        // 点选 类别
        clickType(item) {
            item.status = !item.status
            console.log('item')
            for (var i in this.typeList) {
                if (this.typeList[i].type_id == item.type_id) {
                    if (item.status) {
                        $('.type.search_item[data-id=' + item.type_id + ']').addClass('active')
                        this.type_id = this.typeList[i].type_id
                    } else {
                        $('.type.search_item[data-id=' + item.type_id + ']').removeClass('active')
                    }
                } else {
                    this.typeList[i].status = false
                    $('.type.search_item[data-id=' + item.type_id + ']').siblings().removeClass('active')
                }
            }
            console.log('clickType')
            console.log(this.typeList)
            // 类别 下的级别
            this.getLevelList(this.type_id)
        },
        // 点选 级别
        clickLevel(item) {
            this.selectMore('.level', item, this.levelList)
            console.log('this.levelList')
            console.log(this.levelList)
        },
        // 点选 列表
        clickCate(item) {
            this.selectMore('.cate', item, this.cateList)
        },
        // 点选多个 判断它是否为选中状态
        selectMore(className, item, arr) {
            for (var i in arr) {
                if (arr[i].id == item.id) {
                    if (item.status == 0) {
                        console.log('selectMore')
                        $(className + '.search_item[data-id=' + item.id + ']').addClass('active')
                        console.log($(className + '.search_item[data-id=' + item.id + ']'))
                        item.status = 1
                    } else {
                        $(className + '.search_item[data-id=' + item.id + ']').removeClass('active')
                        item.status = 0
                    }
                }
            }
            // console.log(item)
        },
        // 重置
        reset() {
            // 将省市区重置
            this.selectArea = '全国'
            this.areaNameList = null
            // 将项目重置
            for (var i in this.typeList) {
                this.typeList[i].status = false
            }
            // 将级别重置
            for (var j in this.levelList) {
                this.levelList[j].status = 0
            }
            // 将分类重置
            for (var k in this.cateList) {
                this.cateList[k].status = 0
            }
            $('.search_item').removeClass('active')
        },
        // 确定
        submit() {
            console.log('确定')
            // 关闭弹层
            this.search_status = false
            $('.page_map').removeClass('limitHeight')
            // 项目id数组
            var arr = []
            for (var i in this.typeList) {
                if (this.typeList[i].status) {
                    arr.push(this.typeList[i].type_id)
                }
            }
            this.typeIdList = arr
            // 级别数组
            var levelIdList = []
            for (var j in this.levelList) {
                if (this.levelList[j].status == 1) {
                    levelIdList.push(this.levelList[j].id)
                }
            }
            this.levelIdList = levelIdList
            // 项目cateId数组
            var cateIdList = []
            for (var k in this.cateList) {
                if (this.cateList[k].status == 1) {
                    cateIdList.push(this.cateList[k].id)
                }
            }
            this.cateIdList = cateIdList
            this.dataList = []
            this.pages.page = 1
            this.onLoad()
            // 更新缓存 searchParams
            var searchParams = {
                type_id: this.type_id,
                areaNameList: this.areaNameList,
                cateIdList: this.cateIdList,
                levelIdList: this.levelIdList
            }
            localStorage.setItem('searchParams', JSON.stringify(searchParams))
        },
        // 搜索关键字
        search() {
            this.dataList = []
            this.pages.page = 1
            this.onLoad()
		},
		// js富文本取第一张图片
        imgUrlFun: function(str) {
            var data = "";
            str.replace(/\<img [^>]*src=['"]([^'"]+)[^>]*\>/, function(
                match,
                capture
            ) {
				// console.log('match',match) // 匹配到的字符串
				// console.log('captrue',capture) // 匹配到的子串
                data = capture;
            });
            return data;
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/ .van-image {
    width: 3.07rem;
    height: 3.07rem;
}

.page_map {
    background: transparent;
}

/deep/.van-cell .van-field__control {
    /* color: #212121; */
    color: rgba(0, 0, 0, 0.54);
}
</style>
